import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { Card, Alert, CardDeck, Row, Col, ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';

function renderTooltip(text, props) {
    return (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );
}
export class ModelpopupQualification extends Component {
  constructor(props) {
    super(props);

  }

  
  renderCriteria(criteria, index) {
        
    let width = 0;
    let variant = 'success';
    
    // green 
        width = 48022750.81 / 500000 * 100;
    // // yellow
    //     width = 5003569.58 / 6100000 * 100;

    //     //red 
    //     width = 2003569.58 / 6100000 * 100;

    
    width = width >= 100 ? 100 : width;
    
    if (width < 50) {
        variant = 'danger';
    } else if (width >= 50 && width < 100) {
        variant = 'warning';
    }

    return (
        <Col>
            <OverlayTrigger placement="bottom" overlay={props => renderTooltip(<strong>
                {
                <React.Fragment>
                    <strong>Target: </strong>
                    {'Purchase of ' + 500000+ ' from all vendors'}
                    <br />
                    <strong>Actual: </strong>
                    {'Purchased of ' + 48022750.81+ ' from all vendors'}
                </React.Fragment>
                }
                </strong>, props)}>
                <ProgressBar now={width} variant={variant} />
            </OverlayTrigger>
        </Col>
    );
}

renderCriteria2(criteria, index) {
    
    let width = 0;
    let variant = 'success';
    
    // // green 
    //     width = 48022750.81 / 500000 * 100;
    // yellow
        width = 5003569.58 / 6100000 * 100;

        // //red 
        // width = 2003569.58 / 6100000 * 100;

    
    width = width >= 100 ? 100 : width;
    
    if (width < 50) {
        variant = 'danger';
    } else if (width >= 50 && width < 100) {
        variant = 'warning';
    }

    return (
        <Col>
            <OverlayTrigger placement="bottom" overlay={props => renderTooltip(<strong>
                {
                <React.Fragment>
                    <strong>Target: </strong>
                    {'Purchase of ' + 500000+ ' from all vendors'}
                    <br />
                    <strong>Actual: </strong>
                    {'Purchased of ' + 48022750.81+ ' from all vendors'}
                </React.Fragment>
                }
                </strong>, props)}>
                <ProgressBar now={width} variant={variant} />
            </OverlayTrigger>
        </Col>
    );
}

renderCriteria3(criteria, index) {
    
    let width = 0;
    let variant = 'success';
    
    // // green 
    //     width = 48022750.81 / 500000 * 100;
    // // yellow
    //     width = 5003569.58 / 6100000 * 100;

        //red 
        width = 2003569.58 / 6100000 * 100;

    
    width = width >= 100 ? 100 : width;
    
    if (width < 50) {
        variant = 'danger';
    } else if (width >= 50 && width < 100) {
        variant = 'warning';
    }

    return (
        <Col>
            <OverlayTrigger placement="bottom" overlay={props => renderTooltip(<strong>
                {
                <React.Fragment>
                    <strong>Target: </strong>
                    {'Purchase of ' + 500000+ ' from all vendors'}
                    <br />
                    <strong>Actual: </strong>
                    {'Purchased of ' + 48022750.81+ ' from all vendors'}
                </React.Fragment>
                }
                </strong>, props)}>
                <ProgressBar now={width} variant={variant} />
            </OverlayTrigger>
        </Col>
    );
}
  render() {
    return (
      <Modal
      {...this.props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Member Qualification !!
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <Card className="shadow-sm">
        <Card.Body>
            <Card.Title> <Row> <h4 style = {{marginLeft: "10px"}}> Membership Qualification </h4> 
                         </Row></Card.Title>
            
            <Row>
                
                {/* {this.state.qualification.map(level => */}
                     <Col>
                    <h4 className="d-flex my-2">
                    <span>Tier 1</span>
                        <span className="ml-auto">
                            <React.Fragment>
                                    <span>Qualified</span> <i class="fas fa-check text-success"></i>
                                </React.Fragment> 
                                {/* : <React.Fragment>
                                    <i class="fas fa-times text-danger"></i>
                                </React.Fragment> */}
                        </span>
                    </h4>
                    <div className="border p-2">
                        <Row>
                           {this.renderCriteria(1, 1)}
                        </Row>
                    </div>
                </Col>

                <Col>
                    <h4 className="d-flex my-2">
                    <span>Tier 1</span>
                        <span className="ml-auto">
                            <React.Fragment>
                                    <span>Qualified</span> <i class="fas fa-check text-success"></i>
                                </React.Fragment> 
                                {/* : <React.Fragment>
                                    <i class="fas fa-times text-danger"></i>
                                </React.Fragment> */}
                        </span>
                    </h4>
                    <div className="border p-2">
                        <Row>
                           {this.renderCriteria(1, 1)}
                        </Row>
                    </div>
                </Col>

                <Col>
                    <h4 className="d-flex my-2">
                    <span>Tier 1</span>
                        <span className="ml-auto">
                            <React.Fragment>
                                    <span>Qualified</span> <i class="fas fa-check text-success"></i>
                                </React.Fragment> 
                                {/* : <React.Fragment>
                                    <i class="fas fa-times text-danger"></i>
                                </React.Fragment> */}
                        </span>
                    </h4>
                    <div className="border p-2">
                        <Row>
                           {this.renderCriteria(1, 1)}
                        </Row>
                    </div>
                </Col>
                {/* )} */}
            </Row>
        </Card.Body>
    </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={this.props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
    );
  }
}

export default ModelpopupQualification;
